<blaze-panel contentClass="overflow-auto">
  <div title>Select Project</div>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />

    <!-- This button acts as a placeholder -->
    <button blazeBarButton="primary" [disabled]="true"> Add Data Sets</button>
  </ng-container>

  <div content class="dialog-content overflow-auto">
    <div class="searchbox mb-24">
      <blaze-filter-input
        #filter="filterInputComponent"
        (filtered)="setFilteredProjects($event)"
        [items$]="projects$"
        placeholder="Search Project"
      />
    </div>

    @if (filteredProjects$ | async; as filteredProjects) {
      <blaze-grouped-projects-list
        (projectClick)="onProjectClick($event)"
        [expandAll]="!!filter?.filterInput?.nativeElement?.value"
        [groups]="projectGroups$ | async"
        [projects]="filteredProjects"
      />
    }

    @if ((projects$ | async)?.length === 0) {
      <div class="no-projects-warning text-center"> No projects found to link tables from</div>
    }
  </div>
</blaze-panel>
